// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"13":"adm","553":"candidates","966":"login"}[chunkId] + "." + {"13":"f7509391","553":"102611d4","966":"128db006"}[chunkId] + ".css";
};